<div class="main px-2">
  <div class="row g-3">
    <div class="col-12">
      <app-documento-vinculo-form [dataSet]="dataSet"></app-documento-vinculo-form>
    </div>
    <nz-divider></nz-divider>
    <div class="col-12 d-flex flex-column page-content border border-radius w-100">
      <nz-table
        [nzData]="dataSet"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        (nzQueryParams)="sort($event)"
        [nzNoResult]="semDadosTemplate"
      >
        <thead>
          <tr>
            <th nzColumnKey="dataCadastro" nzShowSort [nzSortFn]="true">Data do Cadastro</th>
            <th nzColumnKey="nomeDocumento" nzShowSort [nzSortFn]="true">Nome Documento</th>
            <th nzColumnKey="tipoDocumentoString" nzShowSort [nzSortFn]="true">Tipo do Documento</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of dataSet">
              <td>{{ item?.dataCadastro | date: 'dd/MM/YYYY' }}</td>
              <td>
                <a nz-button nzType="link" class="link-azul" nz-popover nzPopoverContent="Download" nzPopoverPlacement="top" type="button" (click)="downloadDocumentos(item.arquivoId)">
                  {{ item?.nomeDocumento }}
                </a>
              </td>
              <td >{{ item?.tipoDocumentoString }}</td>
              <td class="text-center">
                <button nz-button nzType="primary" nz-popover nzPopoverContent="Delete" nzPopoverPlacement="top" class="me-3" type="button" (click)="deletarDocumentos(item)">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item type="button" type="button" (click)="downloadDocumentos(item.arquivoId)">
                      <a>Download</a>
                    </li>
                  </ul>
                  <ul nz-menu>
                    <li nz-menu-item type="button" type="button" (click)="deletarDocumentos(item)">
                      <a>Deletar</a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
        </tbody>
      </nz-table>
      <ng-template #footerTemplate>
        <section class="d-flex justify-content-end w-100">
          <app-pagination [itemPorPagina]="10"></app-pagination>
        </section>
      </ng-template>
      <ng-template #semDadosTemplate>
        <div
          class="d-flex align-items-center justify-content-center"
          *ngIf="!dataSet?.length"
        >
          <nz-empty
            [nzNotFoundContent]="'Nenhum registro encontrado'"
          ></nz-empty>
        </div>
      </ng-template>
    </div>
  </div>
</div>
